import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * A chapter of the chapter list, used for chapters with and without a section.
 */
@Component({
    bindings: {
        chapter: '<',
        isActive: '<',
        stateLabel: '<',
        isSourceLanguage: '<',
        translationLabel: '<',
        onToggleMenu: '&',
        onStartEdit: '&',
        onFinishEdit: '&',
        onToggleVisibility: '&',
        onSetVisibilityInAllLanguages: '&',
        onExport: '&',
        onDelete: '&',
        onTranslate: '&'
    },
    template
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/toc/chapter/index.js